if (!customElements.get('geolocation-modal')) {
  customElements.define(
    'geolocation-modal',
    class GeolocationModal extends HTMLElement {
      constructor() {
        super();

        this.accessKey = 'f880653a1d4ba885856045ec468dc7dc';

        this.options = this.querySelectorAll('.geolocation__option a');
        this.options.forEach((option) => {
          option.addEventListener('click', this.onContinue.bind(this));
        });

        this.popup = this.parentElement;
        this.popup.addEventListener('click', (event) => {
          if (event.target === this.popup) {
            this.forceRedirect();
          }
        });

        this.querySelector('[id^="ModalClose-"]').addEventListener('click', () => {
          this.forceRedirect();
        });

        this.init();
      }

      init() {
        // Check if you were sent here automatically, if yes, don't redirect again.
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('redirect')) {
          localStorage.setItem('GLDisplayed', true);
          localStorage.setItem('GLPreferred', window.location.origin);

          return;
        }

        if (window.location.host == 'links.reigningchamp.com') {
          window.location.href = 'https://linktr.ee/reigningchamp';

          return;
        }

        if (localStorage.getItem('GLPreferred')) {
          if (localStorage.getItem('GLPreferred') != window.location.origin) {
            window.location.href = localStorage.getItem('GLPreferred') + window.location.pathname + '?redirect=1';
          }

          return;
        }

        if (localStorage.getItem('GLDisplayed') != 'true' && sessionStorage.getItem('GLDisplayed') != 'true') {
          fetch('https://api.ipstack.com/check?access_key=' + this.accessKey)
            .then((response) => response.json())
            .then((location) => {
              if (window.country == 'ca' && location.country_code != 'CA') {
                //window.location.href = `https://reigningchamp.com${window.location.pathname}?redirect=1`;

                this.show();
                //} else if (window.country == 'usa' && location.country_code == 'CA') {
                //  window.location.href = `https://ca.reigningchamp.com${window.location.pathname}?redirect=1`;
              } else if (window.country == 'usa' && location.country_code == 'CA') {
                this.show();
              }
            });
        }

        sessionStorage.setItem('GLDisplayed', true);
      }

      show() {
        this.parentElement.show();
      }

      hide() {
        this.parentElement.hide();
      }

      forceRedirect() {
        this.options.forEach((option) => {
          if (option.classList.contains('active')) {
            let location = option.dataset.location;

            localStorage.setItem('GLDisplayed', true);
            localStorage.setItem('GLPreferred', location);

            if (window.location.href.indexOf(location) == -1) {
              location += window.location.pathname;

              if (location.indexOf('?') > -1) {
                location += '&redirect=1';
              } else {
                location += '?redirect=1';
              }

              window.location.href = location;
            }
          }
        });
      }

      onContinue(e) {
        e.preventDefault();

        let location = e.target.closest('.link').dataset.location;

        localStorage.setItem('GLDisplayed', true);
        localStorage.setItem('GLPreferred', location);

        if (window.location.href.indexOf(location) == -1) {
          location += window.location.pathname;

          if (location.indexOf('?') > -1) {
            location += '&redirect=1';
          } else {
            location += '?redirect=1';
          }

          window.location.href = location;
        } else {
          this.hide();
        }
      }
    }
  );
}

if (!customElements.get('geolocation-change')) {
  customElements.define(
    'geolocation-change',
    class GeolocationChange extends HTMLElement {
      constructor() {
        super();

        this.close = this.querySelector('.geolocation__cancel');
        this.close.addEventListener('click', this.hide.bind(this));

        this.continue = this.querySelector('.geolocation__continue');
        this.continue.addEventListener('click', this.onContinue.bind(this));
      }

      onContinue() {
        var url = this.getAttribute('data-locale');

        localStorage.setItem('GLDisplayed', true);
        localStorage.setItem('GLPreferred', url);

        url += window.location.pathname == '/account' ? '/account/login' : window.location.pathname;

        if (url.indexOf('?') > -1) {
          url += '&redirect=1';
        } else {
          url += '?redirect=1';
        }

        window.location.href = url;
      }

      show() {
        this.parentElement.show();
      }

      hide() {
        this.parentElement.hide();
      }
    }
  );
}
